// Clone value
const clone = document.getElementById("selected-value-clone"),
  cloneText = clone.textContent,
  cloned = document.getElementById("cloned-info");

cloned.textContent = cloneText;

// Clone price
function clonePrice() {
  let wrapper = document.querySelector("#product-detail"),
    clonePrice = wrapper.querySelector("#main-price"),
    clonePriceClass = clonePrice.classList,
    clonePriceHTML = clonePrice.innerHTML,
    clonedPrice = document.getElementById("cloned-price");

  clonedPrice.className = clonePriceClass;
  clonedPrice.innerHTML = clonePriceHTML;
}
clonePrice();

let selects = document.querySelectorAll(".product-form__input");
selects.forEach(function (item) {
  item.addEventListener("change", function () {
    // Delay for make sure updated
    setTimeout(clonePrice, 1500);
  });
});

// Track scroll
window.addEventListener("scroll", function () {
  const elementTarget = document.getElementById("buy-btn-tracker"),
    stickyEle = document.getElementById("sticky-info"),
    wrapper = document.getElementById("MainContent");

  if (
    window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight &&
    wrapper.getBoundingClientRect().bottom >
      stickyEle.getBoundingClientRect().bottom
  ) {
    stickyEle.classList.add("show");
  } else {
    stickyEle.classList.remove("show");
  }
});
